export enum TPasswordFieldType {
  PASSWORD = 'password',
  SHOWPASSWORD = 'text',
}
